import {
  type AttributionAddToCartInput,
  attributionFindLatestMatchingItem,
} from '../experiments/attribution'
import { recommendationAttributionRead } from '../experiments/recommendation-attribution'
import { searchAttributionRead } from '../experiments/search-attribution'

import {
  udpTrackingImpressionCacheGet,
  udpTrackingImpressionStorageGet,
  udpTrackingImpressionStorageSave,
} from './udpTrackingImpressionStorage'

export const udpTrackingSaveSuccessfulAddToCartAttribution = ({
  isSuccessfullyAddedToCart,
  product,
}: {
  isSuccessfullyAddedToCart: boolean
  product?: AttributionAddToCartInput
}): boolean => {
  if (!product || !isSuccessfullyAddedToCart) {
    return false
  }

  const attributionMatch = {
    offerId: product.offerId,
    productFamilyIds: product.productFamilyIds,
    productId: product.productId,
  }
  const searchClick = attributionFindLatestMatchingItem(
    searchAttributionRead().clicks,
    attributionMatch,
  )

  if (!searchClick || !product.productId) {
    return true
  }

  const recommendationClick = attributionFindLatestMatchingItem(
    recommendationAttributionRead().clicks,
    attributionMatch,
  )
  const recommendationImpression = recommendationClick
    ? udpTrackingImpressionStorageGet(
        product.productId,
        'recommendation',
        recommendationClick.areaId,
      )
    : undefined

  if (
    recommendationClick &&
    recommendationClick.createdAt >= searchClick.createdAt &&
    recommendationImpression?.quantity !== undefined
  ) {
    return true
  }

  udpTrackingImpressionStorageSave({
    attributedUpid: product.productId,
    impression:
      udpTrackingImpressionCacheGet(
        searchClick.productId,
        searchClick.surface,
      ) ??
      udpTrackingImpressionStorageGet(
        searchClick.productId,
        searchClick.surface,
      ),
    impressionOrigin: searchClick.surface,
    quantity: product.quantity,
    upid: searchClick.productId,
  })

  return true
}
